import React, { Component } from "react";
import { ThemeProvider } from "styled-components";
import { Flex } from "rebass";
import { Transition, config } from "react-spring";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
//
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { Clipper } from "./components/Clipper";
//
import { Work } from "./routes/Work";
import { ProjectPage } from "./routes/ProjectPage";
import { About } from "./routes/About";
//
import { theme } from "./theme";
import "./reset.css";
import "./App.css";
import { projects } from "./projects";

const getFirstWithID = (id, list) => {
  return list.reduce((r, c) => {
    if (r) return r;
    if (c.id === id) return c;
    return r;
  }, null);
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false
    };
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        mounted: true
      });
    }, 100);
  }
  render() {
    return (
      <Router>
        <ThemeProvider theme={theme}>
          <Route
            render={({ location }) => (
              <Flex
                className="App"
                flexDirection="column"
                bg="background"
                css={{ height: "100vh" }}
              >
                <Navigation
                  links={[
                    { to: "/", text: "work" },
                    { to: "/about", text: "about" }
                  ]}
                />
                <Flex
                  width={1}
                  flexDirection="column"
                  css={{
                    height: "100%",
                    position: "relative",
                    overflow: "hidden"
                  }}
                >
                  <Transition
                    config={config.slow}
                    items={location}
                    immediate={() => {
                      return !this.state.mounted;
                    }}
                    unique
                    native
                    keys={location => location.pathname}
                    from={{ opacity: 1, clip: 1 }}
                    enter={{ opacity: 1, clip: 0 }}
                    leave={{ opacity: 0, clip: -1 }}
                  >
                    {(location, state, index) => style => {
                      return (
                        <Switch location={location}>
                          <Route
                            path="/"
                            exact
                            render={props => (
                              <Clipper progress={style.clip}>
                                <Work {...props} projects={scrollerData} />
                              </Clipper>
                            )}
                          />
                          <Route
                            path="/about"
                            exact
                            render={props => (
                              <Clipper progress={style.clip}>
                                <About {...props} />
                              </Clipper>
                            )}
                          />
                          <Route
                            path="/project/:id?"
                            exact
                            render={props => {
                              const projectID = props.match.params.id || 0;
                              const project =
                                getFirstWithID(projectID, projects) ||
                                projects[0];
                              return (
                                <Clipper progress={style.clip}>
                                  <ProjectPage {...project} {...props} />
                                </Clipper>
                              );
                            }}
                          />
                        </Switch>
                      );
                    }}
                  </Transition>
                </Flex>
                <Footer />
              </Flex>
            )}
          />
        </ThemeProvider>
      </Router>
    );
  }
}


// const projects = [
//   {
//     title: "designing the code",
//     description:
//       "Lorem ipsum dolor sit amet. t Phasellus eget elit tellus. Curabitur dictum felis eget turpis bibendum sagittis. Praesent tempor bibendum diam sit amet blandit. Curabitur scelerisque rutrum pharetra. Morbi sodales dictum ante non dictum. Phasellus pretium venenatis nulla.",
//     position: "front end developer",
//     id: uuid(),
//     tag: "Never-Sleep",
//     library: { npm: "react", import: "React" },
//     technologies: ["react", "styled components", "rebas"],
//     color: "accentBlue",
//     cover: placeholder,
//     features: [
//       {
//         title: "feature title",

//         imageLeft: placeholder,
//         imageRight: placeholder
//       }
//     ],
//     gallery: [placeholder, placeholder, placeholder, placeholder]
//   },
//   {
//     title: "dasdasd",
//     description:
//       "Lorem ipsum dolor sit amet. t Phasellus eget elit tellus. Curabitur dictum felis eget turpis bibendum sagittis. Praesent tempor bibendum diam sit amet blandit. Curabitur scelerisque rutrum pharetra. Morbi sodales dictum ante non dictum. Phasellus pretium venenatis nulla.",
//     position: "front end developer",
//     tag: "Never-Sleep",
//     id: uuid(),
//     library: { npm: "react", import: "React" },
//     technologies: ["react", "styled components", "rebas"],
//     color: "accentGreen",
//     cover: placeholder,
//     features: [
//       {
//         title: "feature title",

//         imageLeft: placeholder,
//         imageRight: placeholder
//       }
//     ],
//     gallery: [placeholder, placeholder, placeholder, placeholder]
//   }
// ];
const scrollerData = projects.map(
  ({ title, cover, tag, library, color, short, id }) => ({
    title,
    cover,
    tag,
    library,
    color,
    id,
    description: short
  })
);
export default App;
